/**
 * Constants
 */
const D = 'd';
const DD = 'dd';
const M = 'm';
const MM = 'mm';
const MMM = 'mmm';
const Y = 'y';
const YYYY = 'yyyy';
const ORDINAL = '##';

const ST = 'st';
const ND = 'nd';
const RD = 'rd';

const DATE_ROW_COUNT = 5;
const DATE_COL_COUNT = 6;
const MONTH_ROW_COUNT = 3;
const MONTH_COL_COUNT = 2;
const YEAR_ROW_COUNT = 4;
const YEAR_COL_COUNT = 4;

const DOT = '.';
const UNDER_LINE = '_';
const PIPE = '|';
const YEAR_SEPARATOR = ' - ';

const SU = 'su';
const MO = 'mo';
const TU = 'tu';
const WE = 'we';
const TH = 'th';
const FR = 'fr';
const SA = 'sa';

const DEFAULT_LOCALE = 'en';

const ZERO_STR = '0';
const EMPTY_STR = '';
const SPACE_STR = ' ';

const CLICK = 'click';
const KEYUP = 'keyup';
const BLUR = 'blur';
const DISABLED = 'disabled';
const BODY = 'body';
const VALUE = 'value';
const OPTIONS = 'options';
const DEFAULT_MONTH = 'defaultMonth';
const LOCALE = 'locale';
const OBJECT = 'object';
const PX = 'px';
const STYLE = 'style';
const INNER_HTML = 'innerHTML';

const OPTS = 'opts';
const YEARS_DURATION = 'yearsDuration';
const YEARS = 'years';
const VISIBLE_MONTH = 'visibleMonth';
const SELECT_MONTH = 'selectMonth';
const SELECT_YEAR = 'selectYear';
const PREV_VIEW_DISABLED = 'prevViewDisabled';
const NEXT_VIEW_DISABLED = 'nextViewDisabled';
const DATES = 'dates';
const WEEK_DAYS = 'weekDays';
const SELECTED_DATE = 'selectedDate';
const SELECTED_DATE_RANGE = 'selectedDateRange';
const MONTHS = 'months';

const ANIMATION_END = 'animationend';
const ANIMATION_TIMEOUT = 550;
const MY_DP_ANIMATION = 'myDpAnimation';
const ANIMATION_NAMES = ['Fade', 'ScaleTop', 'ScaleCenter', 'Rotate', 'FlipDiagonal', 'Own'];
const IN = 'In';
const OUT = 'Out';

const TABINDEX = 'tabindex';
const TD_SELECTOR = 'table tbody tr td:not(.myDpDaycellWeekNbr)';

const PREVENT_CLOSE_TIMEOUT = 50;

export {
  D,
  DD,
  M,
  MM,
  MMM,
  Y,
  YYYY,
  ORDINAL,
  ST,
  ND,
  RD,
  DATE_ROW_COUNT,
  DATE_COL_COUNT,
  MONTH_ROW_COUNT,
  MONTH_COL_COUNT,
  YEAR_ROW_COUNT,
  YEAR_COL_COUNT,
  DOT,
  UNDER_LINE,
  PIPE,
  YEAR_SEPARATOR,
  SU,
  MO,
  TU,
  WE,
  TH,
  FR,
  SA,
  DEFAULT_LOCALE,
  ZERO_STR,
  EMPTY_STR,
  SPACE_STR,
  CLICK,
  KEYUP,
  BLUR,
  DISABLED,
  BODY,
  VALUE,
  OPTIONS,
  DEFAULT_MONTH,
  LOCALE,
  OBJECT,
  PX,
  STYLE,
  INNER_HTML,
  OPTS,
  YEARS_DURATION,
  YEARS,
  VISIBLE_MONTH,
  SELECT_MONTH,
  SELECT_YEAR,
  PREV_VIEW_DISABLED,
  NEXT_VIEW_DISABLED,
  DATES,
  WEEK_DAYS,
  SELECTED_DATE,
  SELECTED_DATE_RANGE,
  MONTHS,
  ANIMATION_END,
  ANIMATION_TIMEOUT,
  MY_DP_ANIMATION,
  ANIMATION_NAMES,
  IN,
  OUT,
  TABINDEX,
  TD_SELECTOR,
  PREVENT_CLOSE_TIMEOUT,
};
